export default __webpack_public_path__ + "static/media/logo.9c9a38c7.png";